import startupCopy from '../locales/startup-copy.json';

/** 在业务模块不可用时读取可选语言偏好，不依赖 React 或语言运行时。 */
function getStartupCopy() {
  try {
    return startupCopy[localStorage.getItem('tenant-web:language') === 'en-US' ? 'en-US' : 'zh-CN'];
  } catch {
    return startupCopy['zh-CN'];
  }
}

/** 将模块加载失败转为可聚焦的恢复界面，不向用户显示内部异常信息。 */
export function showStartupError(): void {
  const root = document.getElementById('root');
  if (!root) return;
  const copy = getStartupCopy();
  const container = document.createElement('div');
  container.className = 'global-loading-container';
  container.setAttribute('role', 'alert');
  const title = document.createElement('h1');
  title.className = 'global-loading-title';
  title.textContent = copy.title;
  const description = document.createElement('p');
  description.className = 'global-loading-description';
  description.textContent = copy.description;
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = copy.retry;
  // ES 模块失败可能被浏览器缓存；整页刷新才能重新获取入口和依赖。
  retry.addEventListener('click', () => window.location.reload());
  container.append(title, description, retry);
  root.replaceChildren(container);
  document.title = copy.title;
  retry.focus();
}
